import { ComponentType } from "@angular/cdk/portal";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { RecordsManager } from "../../modules/records/records-manager";

export class ClosePlanCommand<
  T extends object & { disabled: boolean },
  S extends IApiService<T> & {
    closePlan: (el: T, formValue: object) => Observable<any>;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  layout: "flat" | "raised" | "normal" = "raised";
  constructor(
    public service: S,
    private dialogComponent: ComponentType<any>,
    private dialogConfig: MatDialogConfig
  ) {}
  execute(el: T, checkbox: MatCheckbox) {
    this.reopenPlan(checkbox);
    this.receiver
      .showConfirmDialog(this.dialogComponent, this.dialogConfig)
      .afterClosed()
      .subscribe((formValue: object) =>
        formValue ? this.closePlan(el, checkbox, formValue) : null
      );
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    return el.disabled || this.receiver.isLoading;
  }

  private reopenPlan(checkbox: MatCheckbox) {
    checkbox.checked = false;
  }

  private onSuccess(res: any, checkbox: MatCheckbox) {
    checkbox.checked = true;

    this.receiver.onSuccess();
  }

  private closePlan(el: T, checkbox: MatCheckbox, formValue: object) {
    this.service.closePlan(el, formValue).subscribe((operationCompleted) => {
      this.onSuccess(operationCompleted, checkbox);
    });
  }
}
